// src/components/Header/CartIcon.jsx
import React, { useState } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import "../../styles/Header-css/Hedaer/HeaderCart.css";

const HeaderCart = ({ cartItemsCount = 0, onCartClick }) => {
  const [showCartPreview, setShowCartPreview] = useState(false);

  const handleCartClick = () => {
    if (onCartClick) {
      onCartClick();
    } else {
      window.location.href = '/cart'; 
    }
  };

  const handleMouseEnter = () => {
    setShowCartPreview(true);
  };

  const handleMouseLeave = () => {
    setShowCartPreview(false);
  };

  return (
    <div 
      className="cart-icon-container"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleCartClick}
    >
      <div className="cart-icon-wrapper">
        <FaShoppingCart className="cart-icon" />
        {cartItemsCount > 0 && (
          <span className="cart-badge">{cartItemsCount}</span>
        )}
      </div>
      
      {showCartPreview && cartItemsCount > 0 && (
        <div className="cart-preview">
          <div className="cart-preview-header">
            <span>Cart ({cartItemsCount})</span>
          </div>
          <div className="cart-preview-content">
            <p>You have {cartItemsCount} items in your cart</p>
            <button className="view-cart-btn">View Cart</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderCart;